// extracted by mini-css-extract-plugin
export default {"button":"AddImageObjectButton_button__IG1CV"};